import { Component, OnInit } from "@angular/core";
import { Angulartics2 } from "angulartics2";

@Component({
  selector: "app-error-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.scss"]
})
export class ErrorNotFoundComponent implements OnInit {

  constructor(
    protected _analytics: Angulartics2,
  ) { }

  ngOnInit(): void {
    // Timeout to allow the URL to update on the next tick
    window.setTimeout(() => {
      this._analytics.eventTrack.next({
        action: "404",
        properties: {
          category: "Error",
          // TODO: Use Angular instead of window.*, see: handleResolverError
          label: window.location.pathname.replace(/[0-9a-f]{8}\-(?:[0-9a-f]{4}\-){3}[0-9a-f]{12}/gi, "{guid}"),
        },
      });
    }, 1);
  }

}
